<template>
    <div>
        <!-- عرض قائمة الاشتراكات -->
        <div v-for="subscription in subscriptions" :key="subscription.id">
            <div class="d-flex flex-stack">
                <!-- رمز الاشتراك -->
                <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 fw-semibold" :style="getStyle(subscription.end_date)">
                        <i :class="isActive(subscription.end_date) ? 'fa fa-check' : 'fa fa-times-circle'"
                            class="text-white"></i>
                    </div>
                </div>

                <!-- تفاصيل الاشتراك -->
                <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                        <a href="#" class="text-gray-800 text-hover-success fs-6 fw-bold">
                            {{ subscription.name }}
                        </a>
                        <span class="text-muted fw-semibold d-block fs-7">
                            {{ isActive(subscription.end_date)
                                ? ` صالح حتى ${formatDate(subscription.end_date)}`
                                : ` الإشتراك منتهي ${formatDate(subscription.end_date)}` }}
                        </span>
                    </div>

                    <!-- إجراءات -->
                    <div class="d-flex gap-2">
                        <a v-if="isActive(subscription.end_date)" href="#"
                            class="btn btn-sm btn-icon btn-light w-100px h-30px"
                            @click.prevent="fetchSubscriptionDetails(subscription.id)">
                            <span class="svg-icon svg-icon-2" style="color: #07c232; font-weight: 600;">
                                <i class="fa fa-graduation-cap" style="color: #07c232;"></i>
                                إختبر نفسك
                            </span>
                        </a>

                        <a v-else href="#" class="btn btn-sm btn-icon btn-bg-light w-100px h-30px"
                            @click.prevent="confirmSubscription(subscription.id)">
                            <span class="svg-icon svg-icon-2" style="color: #f46a6a;font-weight: 600;">
                                <i class="fa fa-sync-alt" style="color: #f46a6a;"></i>
                                تجديد الاشتراك
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="separator separator-dashed my-4"></div>
        </div>
    </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";

export default {
    props: {
        subscriptions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            tests: null,
            token: localStorage.getItem("access_token"),
            subscriptionId: null
        };
    },
    methods: {
        toggleDropdown() {
            const dropdownMenu = document.querySelector("#custom-dropdown .dropdown-menu");
            if (dropdownMenu.style.display === "block") {
                dropdownMenu.style.display = "none";
            } else {
                dropdownMenu.style.display = "block";
            }
        },
        async fetchSubscriptionDetails(subscriptionId) {
            window.location.href = 'qbank-list-quiz?subscriptionId=' + subscriptionId;
        },
        getStyle(endDate) {
            const bgColor = this.isActive(endDate) ? '#07c232' : '#f92828';
            return `background-color: ${bgColor} !important; color: #fff !important;`;
        },
        isActive(endDate) {
            const today = new Date();
            const end = new Date(endDate);
            return end >= today;
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('en-US');
        },
        // ✅ دالة تجديد الاشتراك
        async confirmSubscription(planId) {
            const result = await Swal.fire({
                title: "هل تريد تجديد الاشتراك؟",
                text: "إضغط موافق لتجديد الاشتراك",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3ddc97",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: "إلغاء",
                confirmButtonText: "موافق",
            });

            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${apiUrl}/profile/qbanks/subscription-plans/${planId}/subscribe`, {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    });

                    if (response.ok) {
                        Swal.fire({
                            title: "تم تجديد الاشتراك بنجاح",
                            icon: "success",
                            confirmButtonText: "موافق",
                        }).then(() => {
                            location.reload(); // إعادة تحميل الصفحة لتحديث البيانات
                        });
                    } else {
                        const error = await response.json();
                        Swal.fire({
                            title: "خطأ",
                            text: error.message || "حدث خطأ أثناء تجديد الاشتراك.",
                            icon: "error",
                            confirmButtonText: "موافق",
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        title: "خطأ",
                        text: "لا يمكن تجديد هذا الإشتراك",
                        icon: "error",
                        confirmButtonText: "موافق",
                    });
                }
            }
        },
    },
};
</script>


<style scoped>
.card-title {
    font-size: 1.25rem;
    font-weight: 600;
}

.card-text strong {
    color: #6c757d;
}

.card-footer .btn {
    font-size: 0.9rem;
}
</style>
